// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__38DwZ","boxTitle":"Qualiphy_boxTitle__3RADk","box":"Qualiphy_box__1k1Jk","toggleWrap":"Qualiphy_toggleWrap__3YnXX"};